"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FinanceCalculatorWidget_1 = require("./FinanceCalculatorWidget");
var ModalWithHeader_1 = require("../../../common/components/presentation/ModalWithHeader/ModalWithHeader");
var financeCalculatorContainerStyles_1 = require("./financeCalculatorContainerStyles");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var customEvent_1 = require("../../../common/service/customEvent");
var CalculatorEvents_1 = require("../../../common/enum/CalculatorEvents");
var FinanceCalculatorContainer = react_1.memo(function (_a) {
    var isModalOpen = _a.isModalOpen, toggleModal = _a.toggleModal, carConfiguration = _a.carConfiguration;
    var styles = financeCalculatorContainerStyles_1.default();
    {
        /* @Todo add test for this scenario */
    }
    var receiveFinCalcResponse = react_1.useCallback(function (_a) {
        var detail = _a.detail;
        if (detail) {
            toggleModal(false);
        }
    }, []);
    react_1.useEffect(function () {
        customEvent_1.customEvent.listen(CalculatorEvents_1.default.CONTINUE, receiveFinCalcResponse);
        return function () {
            customEvent_1.customEvent.removeListener(CalculatorEvents_1.default.CONTINUE, receiveFinCalcResponse);
        };
    }, []);
    return (<ModalWithHeader_1.default open={isModalOpen} toggleModal={toggleModal} title={<Translation_1.default id="trans__checkout__next_step__payment_method_section_label"/>} titleProps={{
        'data-test': 'checkout:title:finCalc-title',
        id: 'checkout:finCalc-title',
    }} contentProps={{
        'data-test': 'checkout:finCalc-container',
    }} className={styles.finCalc}>
        {carConfiguration && <FinanceCalculatorWidget_1.default carConfiguration={carConfiguration}/>}
      </ModalWithHeader_1.default>);
});
exports.default = FinanceCalculatorContainer;
